<template>
  <div class="hearder">
    <!-- <div class="time">
      <div class="timeInline">{{time}}</div>
    </div> -->
    <dv-decoration-10 style="width:100%;height:2px;" />
    <!-- <dv-decoration-1 style="width:30%;height:50px;position: absolute;transform: rotate(180deg);"  /> -->
    <div style="width: 100%;text-align: center;vertical-align:center;color: #00ffff;font-size: 2vw;letter-spacing:1vw">
      <!-- <img
        src="../../../assets/img/logo1.png"
        height="50px"
        style="margin-right: 20px;margin-top: 10px;position: relative;bottom: 0px"
      /> -->
      <strong :class="activeComponents == 'Shouye' ? 'defalut' : 'shou'" @click="changeActiveComponents('Shouye')">{{
        headerTitle }}</strong>

    </div>
    <div v-if="homeVoice && JSON.parse(homeVoice).length > 0"
      style="color: red;position: absolute;top: 10px;right: 0%;font-size: 1.2vw;font-weight: 500;color: #00ffff;display: flex;align-items: center;justify-content: flex-end; width: 13%;">
      <i  @click="playAudio(false)" v-if="voiceOpen" class="el-icon-microphone"></i>
      <i style="margin-right: 10px;" @click="playAudio(true)" v-if="!voiceOpen" class="el-icon-turn-off-microphone" ></i>
      
<div  style="height: 23px;width: 23px;" v-if="!voiceOpen"> </div>
      <audio @timeupdate="updateProgress" controls ref="audioRef" style="display: none">
        <source :src=" JSON.parse(homeVoice)[0].url" type="audio/mpeg" />
        不支持音频播放请查看麦克风权限是否开启
      </audio>


      <div class="audio-box" v-if="voiceOpen">

        <div class="audio-right">
          <span>
            <i @click="playAudio1('pause')" v-if="audioStatus == 'play'" class="el-icon-video-pause"></i>
            <i @click="playAudio1('play')" v-if="audioStatus == 'pause'" class="el-icon-video-play"></i>
          </span>
          <div class="progress-bar-bg" id="progressBarBg" v-dragto="setAudioIcon">
            <div class="progress-bar" id="progressBar"></div>
          </div>
          <div class="audio-time" style="min-height: 10px">
            <span class="audio-length-current" id="audioCurTime">{{
        audioStart
      }}</span>/
            <span class="audio-length-total">{{ duration }}</span>
          </div>
        </div>
      </div>

    </div>
   


    <!-- <div v-if="resourceVoice"
      style="color: red;position: absolute;top: -20px;right: 2%;font-size: 1.2vw;font-weight: 500;color: #00ffff">
      <i @click="openVio(false)" v-if="voiceOpen" class="el-icon-microphone"></i>
      <i @click="openVio(true)" v-if="!voiceOpen" class="el-icon-turn-off-microphone"></i>{{ recognizedText }}
    </div>

    <div v-if="ecologicalVoice"
      style="color: red;position: absolute;top: -20px;right: 3%;font-size: 1.2vw;font-weight: 500;color: #00ffff">
      <i @click="openVio(false)" v-if="voiceOpen" class="el-icon-microphone"></i>
      <i @click="openVio(true)" v-if="!voiceOpen" class="el-icon-turn-off-microphone"></i>{{ recognizedText }}
    </div>

    <div v-if="biologicalVoice"
      style="color: red;position: absolute;top: -20px;right: 4%;font-size: 1.2vw;font-weight: 500;color: #00ffff">
      <i @click="openVio(false)" v-if="voiceOpen" class="el-icon-microphone"></i>
      <i @click="openVio(true)" v-if="!voiceOpen" class="el-icon-turn-off-microphone"></i>{{ recognizedText }}
    </div> -->

    <!-- <dv-decoration-1 style="width:30%;height:50px;position: absolute;right: 0;top: 0;transform: rotate(180deg);"  /> -->
  </div>
</template>

<script>
/* eslint-disable */
import Timer from "./Timer";
import moment from "moment";

import { Howl } from 'howler'
import CFG from "@/config/config";
export default {
  props: {
    activeComponents: { type: String, default: 'Shouye' },
    headerTitle: { type: String, default: '' },
    homeVoice: { type: String, default: '' },
    resourceVoice: { type: String, default: '' },
    ecologicalVoice: { type: String, default: '' },
    biologicalVoice: { type: String, default: '' },
  },
  components: {},
  directives: {
    dragto: {
      inserted: function (el, binding, vnode) {
        el.addEventListener(
          "click",
          (e) => {
            let wdiv =
              document.getElementById(
                "progressBarBg"
              ).clientWidth;
            let audio = vnode.context.$refs.audioRef;
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            let ratemin = e.offsetX / wdiv;
            let rate = ratemin * 100;
            document.getElementById("progressBar").style.width =
              rate + "%";
            audio.currentTime = audio.duration * ratemin;
            audio.play();
            binding.value();
          },
          false
        );
      },
    },
  },
  data() {
    return {
      time: null,
      title: "果洛藏族自治州草原一张图",
      voiceOpen: false,
      recognition: null,
      speakAttr: {
        lang: 'zh-CN',
        volume: 1,
        rate: 1,
        pitch: 1,
      },
      recognizedText: "",
      urlprefix: CFG.LOTIP,
      audioStatus: "play",
      audioStart: "0:00",
      duration: "0:00",
      audioVolume: 1,
      audioHuds: false,
      url: '', //mp3地址
      audioPlay: true, //播放状态
      soundBgm: null, //audio js
      audioClass: '' //audio class
    };
  },
  watch: {
    homeVoice: {
      handler(val) {
        console.log(val, "valaaaaaaaaaaaaaaaa");
        this.voiceOpen = false
        this.audioStatus = 'pause'
        let recordAudio = this.$refs.audioRef; 
        if(recordAudio){
          recordAudio.load()
        }
        if (val) {
          console.log("变化了--------------", val)
          this.$nextTick(() => {
            console.log("变化了--------------1", val)
            this.fetch();
          });
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.startTime();

    // this.newAudioDom()

  },
  methods: {


    audioClick() {
      if (this.audioPlay) {
        // 暂停
        this.soundBgm.pause()
        this.audioClass = 'rotate rotate-pause'
      } else {
        // 播放
        this.soundBgm.play()
        this.audioClass = 'rotate'
      }
      this.audioPlay = !this.audioPlay

    },

    fetch() {
      let that = this;

      var myVid = this.$refs.audioRef;
      myVid.loop = false;
      this.audioStart = "0:00";
      // 监听音频播放完毕
      myVid.addEventListener(
        "ended",
        function () {
          that.audioStatus = "pause"; // 显示播放icon
          document.getElementById("progressBar").style.width = "0%"; // 进度条初始化
        },
        false
      );
      if (myVid != null) {
        myVid.oncanplay = function () {
          that.duration = that.transTime(myVid.duration); // 计算音频时长
        };
        myVid.volume = 1; // 设置音量100%
      }
    },
    // 播放暂停控制
    playAudio(play) {
      console.log(this.audioStatus)
      let recordAudio = this.$refs.audioRef; // 获取audio元素
      if (play) {
        if (recordAudio.paused) {
          recordAudio.play();
          this.voiceOpen = true
          this.audioStatus = 'play'
        }
      } else {
        recordAudio.load()
        this.voiceOpen = false
        this.audioStatus = 'pause'
      }
      // if (recordAudio.paused) {
      // 	recordAudio.play();
      //   this.voiceOpen = voiceOpen
      // 	this.audioStatus = audioStatus;
      //   console.log(this.audioStatus)
      // } else {
      // 	recordAudio.pause();
      //   this.voiceOpen = voiceOpen
      // 	this.audioStatus = audioStatus;
      //   console.log(this.audioStatus)
      // }
    },

    // 播放暂停控制
    playAudio1(audioStatus) {
      console.log(this.audioStatus)
      let recordAudio = this.$refs.audioRef; // 获取audio元素
      if (audioStatus == 'play') {
        if (recordAudio.paused) {
          recordAudio.play();
          this.audioStatus = audioStatus;
          console.log(this.audioStatus)
        }
      } else {
        recordAudio.pause();
        this.audioStatus = audioStatus;
      }
      // if (recordAudio.paused) {
      //   recordAudio.play();
      //   this.voiceOpen = voiceOpen
      //   this.audioStatus = audioStatus;
      //   console.log(this.audioStatus)
      // } else {
      //   recordAudio.pause();
      //   this.voiceOpen = voiceOpen
      //   this.audioStatus = audioStatus;
      //   console.log(this.audioStatus)
      // }
    },

    // 更新进度条与当前播放时间
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration;
      if (document.getElementById("progressBar")) {
        document.getElementById("progressBar").style.width =
          value * 100 + "%";
        // console.log(e.target.currentTime, e.target.duration, e.target.currentTime == e.target.duration)
        if (e.target.currentTime == e.target.duration) {
          this.audioStatus = "pause";
        }
      } else {
        // console.log("a-----------pause1")
        this.audioStatus = "pause";
      }
      this.audioStart = this.transTime(this.$refs.audioRef.currentTime);
    },

    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(time) {
      var duration = parseInt(time);
      var minute = parseInt(duration / 60);
      var sec = (duration % 60) + "";
      var isM0 = ":";
      if (minute === 0) {
        minute = "00";
      } else if (minute < 10) {
        minute = "0" + minute;
      }
      if (sec.length === 1) {
        sec = "0" + sec;
      }
      return minute + isM0 + sec;
    },
    setAudioIcon() {
      console.log("aaaaaaaaa")
      this.audioStatus = "play";
    },
    handleShowMuteIcon(val) {
      this.audioVolume = val;
    },
    async hDownload() {
      this.$emit("download");
    },

    openVio(flag) {
      if (flag) {
        if (window.SpeechRecognition || window.webkitSpeechRecognition) {
          const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
          this.recognition = new SpeechRecognition();
          this.recognition.lang = 'zh-CN';
          this.recognition.onresult = (event) => {
            alert(event.results[0][0].transcript);
            this.recognizedText = event.results[0][0].transcript;
            const transcript = event.results[0][0].transcript;
            this.handleVoiceCommand(transcript);
          };
          this.recognition.onerror = (event) => {
            console.error('识别出错：', event.error);
          };
          this.recognition.start();
          this.speak("你好，草精灵已上线，请问有什么可以帮助你！", this.speakAttr)
          this.voiceOpen = true
        } else {
          alert('你的浏览器不支持语音识别功能');
        }
      } else {
        if (this.recognition) {
          this.recognition.stop();
        }
        this.speak("草精灵已下线，下次有事在找我吧！", this.speakAttr)
        this.voiceOpen = false
      }

    },
    speak(content, attr) {
      if ('speechSynthesis' in window) {
        const speech = new SpeechSynthesisUtterance(content.toString());
        speech.lang = attr.lang || 'zh-CN'; // 设置语言为中文
        speech.volume = attr.volume || 1;     // 设置音量
        speech.rate = attr.rate || 1;       // 设置语速
        speech.pitch = attr.pitch || 1;      // 设置音高
        // 监听开始播报
        speech.onstart = () => {
        };
        // 监听结束播报
        speech.onend = () => {
        };
        // 监听播报异常
        speech.onerror = () => {
        };
        window.speechSynthesis.speak(speech);
      } else {
        alert('您的浏览器不支持语音合成功能');
      }
    },

    // 调用语音播报函数
    callSpeakFunc() {
      console.log("播放--------------")
      let content = "安塞区草原一张图展示了安塞区草原的详细信息，包括资源状况、生态状况和有害生物状况。以下是所有信息的综合分析：资源状况：草地面积：59.61万亩，草地类型：7类28型，分别为：温性典型草原类：43.74万亩、暖性灌草丛类：4.68万亩、温性荒漠草原类：4.24万亩、暖性草丛类：3.34万亩、温性荒漠草丛类：3.15万亩。草原等级：2级草原：0.14万亩、3级草原：5.23万亩、4级草原：15.22万亩、5级草原：28.29万亩、6级草原：9.4万亩、7级草原：1.28万亩、8级草原：0.05万亩。生态状况：退化草原面积：17.65万亩、无退化：41.95万亩（70.39%）、轻度退化：13.77万亩（23.11%）、中度退化：3.22万亩（5.4%）、重度退化：0.66万亩（1.11%）。安塞区综合植被盖度为：59.83%，各个街道的综合植被盖度如下：白坪街道：61.39%、高武沟街道：61.92%、砖窑湾镇：61.61%、金明街道：64.55%、锁刀湾镇：45.17%、高桥镇：62.34%。草原有害生物状况常见有害鼠：3种，分别为中华鼢鼠、达乌尔黄鼠、达乌尔鼠兔。常见虫害：10种，分别为鼓翅皱膝螳等。常见毒害草：12种，分别为：地锦、大蓟、小蓬草、针叶黄华、杠柳。详细分析：资源丰富：安塞区的草地面积较大，类型多样，其中温性典型草原类占主导地位。生态问题：虽然大部分草地无退化，但仍有部分草地存在不同程度的退化问题，需要采取措施进行保护和恢复。有害生物：存在多种有害鼠、虫害和毒害草，对草原生态系统构成威胁，需要进行有效的防治。总结：安塞区的草原资源丰富，但面临一定的生态退化和有害生物问题。需要加强管理和保护措施，以维持草原生态系统的健康和稳定。具体措施可以包括：加强退化草原的恢复和治理。针对有害生物进行有效的防治。提高综合植被盖度，增强草原生态系统的稳定性。"
      this.speak(content, this.speakAttr)
    },
    startRecognition() {
      if (window.SpeechRecognition || window.webkitSpeechRecognition) {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.lang = 'zh-CN';
        recognition.onresult = (event) => {
          this.recognizedText = event.results[0][0].transcript;
          const transcript = event.results[0][0].transcript;
          this.handleVoiceCommand(transcript);
        };
        recognition.onerror = (event) => {
          console.error('识别出错：', event.error);
        };
        recognition.start();
      } else {
        alert('你的浏览器不支持语音识别功能');
      }


    },
    handleVoiceCommand(command) {
      if (command.includes("打开资源状况")) {
        // 执行打开网站的操作
        if (this.activeComponents != 'resourceStatus') {
          this.speak("收到指令，正在打开中！", this.speakAttr)
          this.$emit("changeActiveComponents", 'resourceStatus')
        } else {
          this.speak("当前正在资源状况大屏！", this.speakAttr)
        }
      } else if (command.includes("打开草原有害生物状况")) {
        // 执行播放音乐的操作
        if (this.activeComponents != 'pestStatus') {
          this.speak("收到指令，正在打开中！", this.speakAttr)
          this.$emit("changeActiveComponents", 'pestStatus')
        } else {
          this.speak("当前正在草原有害生物状况大屏！", this.speakAttr)
        }
      } else if (command.includes("打开生态状况")) {
        // 执行播放音乐的操作
        if (this.activeComponents != 'ecologicalCondition') {
          this.speak("收到指令，正在打开中！", this.speakAttr)
          this.$emit("changeActiveComponents", 'ecologicalCondition')
        } else {
          this.speak("当前正在生态状况大屏！", this.speakAttr)
        }
      } else if (command.includes("回到首页")) {
        // 执行播放音乐的操作
        if (this.activeComponents != 'Shouye') {
          this.speak("收到指令，正在打开中！", this.speakAttr)
          this.$emit("changeActiveComponents", 'Shouye')
        } else {
          this.speak("当前正在首页大屏！", this.speakAttr)
        }
      } else if (command.includes("分析大屏")) {
        this.callSpeakFunc()
      } else if (command.substring(0, 3) == "草精灵") {
        this.speak("我在，请问主人有什么吩咐！", this.speakAttr)
      } else {
        this.speak("主人，你说的什么，我听不懂，我目前还在努力学习，请换个指令吧！", this.speakAttr)
      }
    },
    changeActiveComponents(val) {
      if (this.activeComponents != 'Shouye') {
        this.$emit("changeActiveComponents", 'Shouye')
      }
    },
    startTime() {
      new Timer(1000, 999, () => {
        this.time = moment().format("YYYY-MM-DD h:mm:ss");
      });
    }
  },

};
</script>

<style lang="scss" scoped>
.defalut {
  cursor: default;
}

.shou {
  cursor: pointer;
}

.disabled {
  pointer-events: none;
}

.hearder {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/large-screen-img/topBanner.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .time {
    position: absolute;
    left: 4%;
    top: 10%;
    width: 300px;
    height: 20%;
    backgroundposition: "center";
    backgroundrepeat: "no-repeat";
    backgroundsize: "contain";

    .timeInline {
      font-size: 25px;
      color: #00e3e3;
    }
  }
}

.tips {
  float: right;
}

.audio-box {
  display: flex;
  align-items: center;
  user-select: none;
  width: 300px;

  .play-icon {
    cursor: pointer;
    font-size: 20px;
  }

  .audio-right {
    margin-right: 10px;
    width: 100%;
    height: 23px;
    line-height: 23px;
    // background: #f6f6f6;
    border-radius: 6px;
    display: flex;
    // padding: 0 15px;

    .progress-bar-bg {
      // background-color: #fff;
      background-color: rgba($color: #00ffff, $alpha: 0.8);
      flex: 1;
      position: relative;
      height: 10px;
      top: 50%;
      transform: translateY(-50%);
      margin-top: -1px;
      cursor: pointer;
      margin: 0 3px;
      border-radius: 5px
    }

    .progress-bar {
      background-color: #08b7ac;
      width: 0%;
      height: 10px;
      border-radius: 5px;
    }

    .audio-time {
      overflow: hidden;
      font-size: 14px;

      .audio-length-total {
        float: right;
      }

      .audio-length-current {
        float: left;
      }
    }
  }
}
</style>
